
// these properties will be available from anywhere via this.property
export const constants = {
    isTouch: "ontouchstart" in window ? function () {document.body.classList.add("touch"); return true;}() : function () {document.body.classList.add("no-touch"); return false;}(),
    body: $("body"),
    isInViewport: function (obj, coefficientOffsetVH) {
        let offsetTop = parseInt(obj.offset().top);
        let winScrollTop = $(window).scrollTop();
        let bottomPosition = parseInt(offsetTop + obj.outerHeight());
        let winHeight = $(window).height();
        let diffHeight = coefficientOffsetVH == 0 ? -5 : winHeight / 100 * coefficientOffsetVH;

        return !(bottomPosition < winScrollTop || offsetTop - diffHeight > winScrollTop + winHeight);
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js